import { useSyncExternalStore } from 'react';
import type { GameSession, SessionSnapshot } from './session';

export function useSession(session: GameSession): SessionSnapshot {
  return useSyncExternalStore(
    (listener) => session.subscribe(listener),
    () => session.getSnapshot(),
    () => session.getSnapshot(),
  );
}
